// extracted by mini-css-extract-plugin
module.exports = {"container":"healthy-label_container___KbyR","blinker":"healthy-label_blinker__AMFk0"};